<template lang="pug">
  section
    b-container
      h2.mt-0 {{ `Good ${makeMoment()}, ${account.user.firstname}` }}
      content-loader(v-if="alert.loading")
      .row(v-else-if="dashboardData")
        .col-md-6
          p DASHBOARD
          .row
            .col-12.py-2
              b-card.highlight
                .row.pb-2
                  .col-6
                    p.my-0 ACTIONS
                  .col-6.text-right
                    font-awesome-icon(icon="bell")
                router-link.d-block(v-if="dashboardData.artist.pending>0", :to="{name: 'Artists'}")
                  b-badge.mr-2 {{ dashboardData.artist.pending }}
                  span NEW APPLICATIONS
                router-link.d-block(v-if="dashboardData.art.pending>0", :to="{name: 'Art'}")
                  b-badge.mr-2 {{ dashboardData.art.pending }}
                  span PENDING PIECES
                router-link.d-block(v-if="rentals.length>0", :to="{name: 'Rentals'}")
                  b-badge.mr-2 {{ rentals.length }}
                  span RENTALS TO RETURN
                router-link.d-block(v-if="payouts>0", :to="{name: 'PayoutsEligible'}")
                  b-badge.mr-2 {{ payouts.length }}
                  span PAYOUTS
            .col-12.py-2
              b-card
                b-container.d-flex.justify-content-around
                  span.mx-1
                    font-awesome-icon(icon="eye")
                    span.ml-2 {{ dashboardData.analytics.count_show }}
                  span.mx-1
                    font-awesome-icon(icon="mouse-pointer")
                    span.ml-2 {{ dashboardData.analytics.count_view }}
                  span.mx-1
                    font-awesome-icon(icon="heart")
                    span.ml-2 {{ dashboardData.analytics.count_love }}
                  //- span.mx-1
                    font-awesome-icon(icon="shopping-cart")
                    span.ml-2 {{ dashboardData.analytics.count_cart }}
                  //.col-6.text-center
                    i.fa.fa-user.fa-2x.mt-2
                  //.col-6.text-right
                    h3.m-1 {{ dashboardData.customer.total }}
                    span.text-muted Users
            .col-12.col-md-12.py-2
              b-card
                .row
                  .col-2.text-center
                    i.fa.fa-pound-sign.fa-2x.mt-2
                  .col-5.text-right
                    h3.m-1 {{ formatRands(dashboardData.commission.commission_sales) }}
                    span.text-muted Sales profit
                  .col-5.text-right
                    h3.m-1 {{ formatRands(dashboardData.commission.commission_rentals) }}
                    span.text-muted Rental profit
            .col-6.py-2
              b-card
                .row
                  .col-6.text-center
                    i.fa.fa-user.fa-2x.mt-2
                  .col-6.text-right
                    h3.m-1 {{ dashboardData.customer.total }}
                    span.text-muted Users
            .col-6.py-2
              b-card
                .row
                  .col-6.text-center
                    i.fa.fa-address-card.fa-2x.mt-2
                  .col-6.text-right
                    h3.m-1 {{ dashboardData.artist.active }}
                    span.text-muted Artists
            .col-6.py-2
              b-card
                .row
                  .col-6.text-center
                    i.fa.fa-clone.fa-2x.mt-2
                  .col-6.text-right
                    h3.m-1 {{ dashboardData.art.available }}
                    span.text-muted Art
                //- router-link.d-block(:to="{name: 'PayoutsEligible'}")
                //-   b-badge.mr-2(:variant="dashboardData.payout.clear>0?'dark':'light'") {{ dashboardData.payout.clear }}
                //-   span Payouts cleared to pay
        .col-md-6.py-2
          p
            | LIVE ORDERS
            a.ml-2(@click="getOrders")
              font-awesome-icon.mr-2(icon="sync-alt")
          nothing(v-if="orderLines.length == 0")
          div(v-for="orderLine in orderLines", :key="orderLine.id")
              router-link(:to="{ name: 'Order', params: { orderId: orderLine.customer_order_id } }")
                b-card.mb-3.highlight
                  .container
                    .row.text-center
                      .col-6.text-md-left
                        h4.mt-0 {{ orderLine.title }}
                        p {{ orderLine.artist_name }}
                        b-badge(variant="light") {{ orderLine.type.toUpperCase() }}
                        small {{ orderLine.created_pretty }}
                      .col-md-6.text-md-right.pt-3
                        span.spanOrderConfirmed.text-success {{ orderLine.status.toUpperCase()}}
        //- .col-md-6.py-2
          b-card
            doughnut-chart(:height='300', :chart-data="chartDoughnutData", :chart-options="chartDoughnutOptions")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import { mapState } from 'vuex';
import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import DoughnutChart from '@/components/charts/DoughnutChart';

export default {
  name: 'ServiceDashboard',
  components: {
    ContentLoader,
    DoughnutChart,
  },
  mixins: [standardMix],
  data() {
    return {
      isConnected: false,
      timestamp: '',
      dashboardData: null,
      orderLines: [],
      payouts: [],
      rentals: [],
      chartDoughnutData: {
        datasets: [
          {
            data: [],
            backgroundColor: ['#000000', '#ffffff'],
            // maxBarThickness: 50,
            // backgroundColor: '#007bff',
            // label: 'Income',
          },
        ],
        labels: [],
      },
      chartDoughnutOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 85,
        legend: {
          display: true,
          position: 'left',
          alignment: 'center',
        },
      },
    };
  },
  computed: {
    ...mapState('alert', ['alert']),
  },
  methods: {
    makeMoment() {
      const today = new Date();
      const hour = today.getHours();
      let phase = '';
      if (hour < 12) phase = 'morning';
      else if (hour < 18) phase = 'afternoon';
      else phase = 'evening';
      return phase;
    },
    async getOrders() {
      this.orderLines = await apiService.getOrderLines({ status: ['paid', 'confirmed', 'shipping', 'pending'] });
    },
  },
  async created() {
    this.busy();
    try {
      this.dashboardData = await apiService.getDashboard(this.profileId);
      this.getOrders();
      this.payouts = await apiService.getPayoutsEligible();
      this.rentals = await apiService.getRentals({ status: ['cancelled'] });
      // this.chartIncomeData.labels = volumeData.map(item => item.week);
      // this.chartIncomeData.datasets[0].data = volumeData.map(item => item.total);
      this.chartDoughnutData.labels = ['Sales', 'Rentals'];
      this.chartDoughnutData.datasets[0].data = [this.dashboardData.commission.commission_sales, this.dashboardData.commission.commission_rentals];
      this.clear();
    } catch (error) {
      this.error(error);
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Dashboard.vue